import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './quasar'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
// import commonMixin from './common/commonMixin.js'
// import Menu from './components/Menu.vue'
// import InputModal from 'bootstrap-vue-input-modal'

import { BootstrapVue, IconsPlugin, LayoutPlugin, PaginationPlugin } from 'bootstrap-vue'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCookie)
Vue.use(Vuex)
    // Vue.mixin({})
    // Vue.mixin(commonMixin)

// Install BootstrapVue
Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
    // Grid System
Vue.use(LayoutPlugin)
    // Pagination
Vue.use(PaginationPlugin)
    // Vue.use(InputModal)


Vue.prototype.$showLoading = function() {
    this.$q.loading.show()

    // hiding in 2s
    this.timer = setTimeout(() => {
        this.$q.loading.hide()
        this.timer = void 0
    }, 2000)
}
Vue.prototype.$hideLoading = function() {
    if (this.timer !== void 0) {
        clearTimeout(this.timer)
        this.$q.loading.hide()
    }
}

Vue.prototype.$defaultUrl = window.location.origin;
Vue.prototype.$uat_eserviceUrl = "https://utltca01.qhms.com/spa/demo/eservice_portal_new";
// Vue.prototype.$currentUrl = (window.location.pathname == 'logout' ? window.location.origin : window.location.origin + window.location.pathname);
Vue.prototype.$currentUrl = (window.location.pathname == '/spa/demo/eservice_portal_new/logout' ? this.$uat_eserviceUrl : window.location.origin + window.location.pathname);
Vue.prototype.$encodeStr = "aHR0cDovL2xvY2FsLnFobXMuY29tLw";

const store = new Vuex.Store({
    state: {
        authJson: {}
    },
    mutations: {
        setAuthJson(state, authJson) {
            //console.log("VUEX.mutations setAuthJson", authJson);
            state.authJson = authJson
        }
    }
})
var vm = new Vue({
        router,
        store,
        // Vuetify,
        components: {
            // Menu
            //,
            // 'b-input-modal':InputModal 
        },
        render: h => h(App)
    }).$mount('#app')
    // vm.getAuth();
export default vm